import Vue from "vue";
import VueApollo from "vue-apollo";
import ApolloClient from "apollo-client";
import { split } from "apollo-link";
import { HttpLink } from "apollo-link-http";
import { WebSocketLink } from "apollo-link-ws";
import { setContext } from "apollo-link-context";
import { getMainDefinition } from "apollo-utilities";
import { InMemoryCache } from "apollo-cache-inmemory";
import { SubscriptionClient } from "subscriptions-transport-ws";
import getAuthData from "@/utils/getAuthData";

const uri = process.env.VUE_APP_GRAPHQL;
const socketUri = process.env.VUE_APP_SOCKET_SERVER as string;

const httpLink = new HttpLink({ uri });
const authLink = setContext(async () => await getAuthData());
const authedHttpLink = authLink.concat(httpLink);
// Create a WebSocket link:

const subscriptionClient = new SubscriptionClient(socketUri, {
  lazy: true,
  reconnect: true,
  timeout: 30000,
  connectionParams: async () => await getAuthData(),
});

const wsLink = new WebSocketLink(subscriptionClient);

const link = split(
  // split based on operation type
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  authedHttpLink
);

class ApolloClientWS extends ApolloClient<InMemoryCache> {
  constructor(props: any) {
    super(props);

    this.closeSocketConnection = this.closeSocketConnection.bind(this);
  }

  closeSocketConnection() {
    return subscriptionClient.close();
  }
}

export const hasuraClient = new ApolloClientWS({
  link,
  cache: new InMemoryCache(),
  connectToDevTools: true,
});

Vue.use(VueApollo);

const apolloProvider = new VueApollo({
  defaultClient: hasuraClient,
  defaultOptions: {
    $query: {
      fetchPolicy: "network-only",
    },
    $loadingKey: "loading",
  },
});

export default apolloProvider;
